var _defs, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKptacLogo = function SvgKptacLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "kptac-logo_svg__Layer_1",
    viewBox: "0 0 728.69 194.32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "kptac-logo_svg__linear-gradient",
    x1: 72.91,
    x2: 126.59,
    y1: 90.04,
    y2: 36.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dedede",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kptac-logo_svg__linear-gradient-2",
    x1: 75.54,
    x2: 136.68,
    y1: 96.37,
    y2: 157.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dedede",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("style", null, ".kptac-logo_svg__cls-3{stroke-width:0;fill:#f5333f}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.16,
    cy: 97.16,
    r: 97.16,
    className: "kptac-logo_svg__cls-3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m568.81 50.24-41.86 93.84h26.54l6.91-15.43h39.76l6.91 15.43h26.54l-41.99-93.84zm.15 59.28 11.32-25.28 11.32 25.28zM339.08 50.24h-34.27l-41.65 41.64 52.19 52.2h34.26L297.4 91.89zm92.13 9.19c-7.19-5.98-17.42-9.19-29.81-9.19h-40.87v93.84h24.2v-24.99h16.67c12.39 0 22.62-3.21 29.81-9.17s11.2-14.69 11.19-25.18c.02-10.56-3.99-19.32-11.19-25.3Zm-17.54 35.59c-2.82 2.36-7.26 3.77-13.44 3.77h-15.51V70.52h15.51c6.18 0 10.62 1.41 13.44 3.79 2.81 2.38 4.25 5.76 4.27 10.41-.02 4.58-1.46 7.93-4.27 10.29Zm122.54-44.78h-82.26v20.29h29.03v73.55h24.19V70.53h29.04zm175.76 63.91c-5.78 6.72-12.78 10.03-21.31 10.05-8.01 0-14.74-2.79-19.5-7.53-4.75-4.74-7.57-11.45-7.58-19.52 0-8.07 2.83-14.78 7.58-19.52 4.76-4.73 11.48-7.52 19.5-7.53 8.52.02 15.54 3.33 21.32 9.94l1.08 1.24 15.63-14.42-.96-1.17c-8.78-10.64-22.23-16.45-38.09-16.44-14.32 0-26.89 4.96-35.88 13.47-8.99 8.49-14.36 20.52-14.35 34.43 0 13.9 5.36 25.93 14.34 34.43 8.97 8.5 21.51 13.47 35.77 13.47 15.99.01 29.45-5.8 38.23-16.57l.95-1.17-15.64-14.42-1.08 1.26Zm-473-63.91v93.84h24.19V50.24z",
    className: "kptac-logo_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kptac-logo_svg__linear-gradient)",
    strokeWidth: 0,
    d: "m88.17 91.89 41.68-41.65H95.58L53.93 91.88z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kptac-logo_svg__linear-gradient-2)",
    strokeWidth: 0,
    d: "m53.93 91.88 52.19 52.2h34.27L88.17 91.89z"
  })));
};
export default SvgKptacLogo;